module.exports = __webpack_public_path__ + "img/list-item-marker.b53a3f4b.svg";